import { type UseQueryResult, useQuery } from 'react-query';
import {
  CompanyAccountingPolicyService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_CompanyAccountingPolicyDto,
} from '../../services/wealthlane-identity-services';

const useGetCompanyAccountingPolicyById = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  groupId?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_CompanyAccountingPolicyDto | undefined,
  unknown
> => {
  return useQuery(
    ['getCompanyAccountingPolicyByGroup', groupId],
    async () => {
      if (groupId != null && groupId !== '') {
        return await handleRequest(
          CompanyAccountingPolicyService.getApiIdentityApiCompanyAccountingPolicy1(
            '',
            groupId,
            undefined,
            '',
            0,
            100
          )
        );
      }
    },
    {
      enabled: groupId != null && groupId !== '',
    }
  );
};

export default useGetCompanyAccountingPolicyById;
